import React, { useEffect, useState } from 'react';
import {
    IonContent,
    IonHeader,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
} from '@ionic/react';
import { getJobChecklists } from '../utilities/Storage';
import {Toolbar} from "./Toolbar";

export default function JobChecklists({
    history,
    match,
}) {

    const { id } = match.params;

    const [ checklists, setChecklists ] = useState();

    useEffect(() => {
        getJobChecklists(id).then(cl => setChecklists(cl));
    }, []);

    if (!checklists) {
        return null;
    }

    const pageTitle = `${ id } checklists`;

    return (
        <IonPage>
            <IonHeader>
                <Toolbar title={pageTitle} backButtonHref="/" />
            </IonHeader>
            <IonContent>
                <IonList lines="full">
                    { checklists && checklists.map(cl =>
                        <IonItem
                            key={ cl.id }
                            button
                            detail
                            onClick={ () => {
                                history.push(`/job/${ id }/checklists/${ cl.id }`);
                            } }
                        >
                            <IonLabel>
                                { cl.pmschecklist.name }<br />
                                { cl.updateddatetime }
                            </IonLabel>
                        </IonItem>,
                    ) }
                </IonList>
            </IonContent>
        </IonPage>
    );
}
